import * as React from 'react'

import Button, { ButtonProps } from 'components/Button'
import { MySpinner } from 'components/MySpinner/MySpinner'

export interface LoadingButtonProps extends ButtonProps {
  loading?: boolean
}

export const LoadingButton: React.FC<LoadingButtonProps> = React.forwardRef<HTMLAnchorElement | HTMLButtonElement, LoadingButtonProps>(({
  loading,
  children,
  ...rest
}, ref) => {
  return (
    <Button ref={ref} {...rest}>
      {loading && <MySpinner size="small" data-testid='loading-spinner' isInButton className="my-u-pr--4" />}
      {children}
    </Button>
  )
})

export default LoadingButton
